import { render } from "./bindMemberModel.vue?vue&type=template&id=1d4e36b3"
import script from "./bindMemberModel.vue?vue&type=script&lang=js"
export * from "./bindMemberModel.vue?vue&type=script&lang=js"

import "./bindMemberModel.vue?vue&type=style&index=0&id=1d4e36b3&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__